<mat-dialog-content class="p-0">
  <h1>กรุณากรอกข้อมูลให้ครบถ้วน</h1>
  @if(!data.firstName){
  <p>-ชื่อ</p>
  } @if(!data.lastName){
  <p>-นามสกุล</p>
  } @if(!data.checkPatternEmail){
  <p>-ระบุอีเมลไม่ถูกต้อง</p>
  } @if(!data.phone || !data.phonePattern){
  <p>-หมายเลขโทรศัพท์มือถือของผู้ซื้อ</p>
  }
  <!-- ไม่ใช่ป้ายแดง -->
  @if(!data.carNumber){
  <p>-รายละเอียด ของเลขทะเบียนรถยนต์</p>
  } @if(!data.province){
  <p>-รายละเอียด จังหวัดเลขทะเบียนรถยนต์</p>
  } @if(!data.bandCar){
  <p>-ยี่ห้อรถยนต์</p>
  } @if(!data.modelCar){
  <p>-รุ่นรถยนต์</p>
  } @if(!data.colorCar){
  <p>-สีรถยนต์</p>
  } @if(!data.dateTyre){
  <p>-วัน เดือน ปี ที่ทำการติดตั้ง</p>
  } @if(!data.provinceStoreMain){
  <p>-จังหวัดศูนย์บริการ</p>
  }@if(!data.locationStore){
  <p>-ศูนย์บริการที่ทำการติดตั้ง</p>
  } @if(!data.bandStore){
  <p>-ชื่อร้าน</p>
  } @if(!data.addressStore){
  <p>-ที่อยุ่</p>
  } @if(!data.provinceStore){
  <p>-จังหวัดศูนย์บริการ</p>
  } @if(!data.postal){
  <p>-รหัสไปรษณีย์</p>
  }
  <!-- @if(!data.franchiseCar){
  <p>-ชื่อร้านตัวแทนจำหน่ายอย่างเป็นทางการ</p>
  } -->
  @if(!data.img){
  <p>-แนบรูปใบเสร็จ</p>
  } @if(!data.agreementAccept){
  <p>-กรุณายอมรับในเงื่อนไขการรับประกัน</p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>ปิด</button>
</mat-dialog-actions>